/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicContinuityOfCareModule
 */
export interface PublicContinuityOfCareModule {
    /**
     * 
     * @type {boolean}
     * @memberof PublicContinuityOfCareModule
     */
    enabled?: boolean;
    /**
     * Surfaced so the booking flow only demands a primary-practitioner choice when the tenant actually wants one. The client must gate on this AND the patient's has_selected_primary flag — patients carry a stale flag from before the tenant turned selection off.
     * @type {boolean}
     * @memberof PublicContinuityOfCareModule
     */
    require_selection?: boolean;
}

/**
 * Check if a given object implements the PublicContinuityOfCareModule interface.
 */
export function instanceOfPublicContinuityOfCareModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicContinuityOfCareModuleFromJSON(json: any): PublicContinuityOfCareModule {
    return PublicContinuityOfCareModuleFromJSONTyped(json, false);
}

export function PublicContinuityOfCareModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicContinuityOfCareModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'require_selection': !exists(json, 'require_selection') ? undefined : json['require_selection'],
    };
}

export function PublicContinuityOfCareModuleToJSON(value?: PublicContinuityOfCareModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'require_selection': value.require_selection,
    };
}

